// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"70":"f79e0003","91":"15d34c1c","220":"8313ecf5","370":"52ddc662","792":"bc7a8e7c","871":"681c3bbb"}[chunkId] + ".js";
};